export default __webpack_public_path__ + "static/media/spade-img.897e1595.webp";